import {useRef, useState} from "react";

export const useChangeVisibility = (
    getElems: () => string[],
    innerHeightThreshold: number,
    enableScrollDownNegativeSelection = false // TODO: we should define it for each element
): [string | null, (text: string) => (isVisible: boolean) => void, number] => {
    /**
     * Browser variables
     */
    let viewportHeight = 0;
    let windowScroll = 0;
    try {
        viewportHeight = window.innerHeight - innerHeightThreshold;
        windowScroll = window.scrollY;
    } catch {
        //
    }

    const [visibleElem, setVisibleElem] = useState<string | null>(null);
    const prevScrollRef = useRef(windowScroll); // prev `changeVisibility` scroll value
    const changeVisibility = (text: string) => (isVisible: boolean) => {
        const scroll = window.scrollY;
        if (isVisible) {
            setVisibleElem(text);
        } else if (visibleElem === text) {
            const elems = getElems();
            const idx = elems.indexOf(text);
            if (idx === -1) {
                return;
            }

            if (prevScrollRef.current < scroll) {
                // scroll down - do NOT update - base state only on `isVisible` true
                if (enableScrollDownNegativeSelection) {
                    setVisibleElem(idx >= elems.length - 1 ? null : elems[idx + 1]);
                }
            } else {
                // scroll up - update - because we base on top element border
                setVisibleElem(idx <= 0 ? null : elems[idx - 1]);
            }
        }
        prevScrollRef.current = scroll;
    };

    return [visibleElem, changeVisibility, viewportHeight];
};
